export default {
      id: "reefer-heat-usage",
      viewBox: "0 0 24 32",
      url: __webpack_public_path__ + "img/icons.svg#reefer-heat",
      toString: function () {
        return this.url;
      }
    }